import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EMRService } from '../EMR.service';
import { SurgicalHistoryModel } from '../HistoryModels/surgicalhistory.model';
import { DatePipe } from '@angular/common';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
import { HelplistService } from 'app/helplist.service';
import { Emr_delete_confirmation_boxComponent } from '../emr_delete_confirmation_box/emr_delete_confirmation_box.component';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { AddNewSurgeryComponent } from './add-new-surgery/add-new-surgery.component';
import { HelpListPopupComponent } from '../Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { DynamicHelpListComponent } from '../Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';

@Component({
  selector: 'app-NewSurgery',
  templateUrl: './NewSurgery.component.html',
  styleUrls: ['./NewSurgery.component.scss']
})
export class NewSurgeryComponent implements OnInit {
  destroynewsugical$: Subject<boolean> = new Subject<boolean>();
  private filterTerm: any;
  private showspinner: boolean = false;
  private catselected = -1;
  private DoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private todaysdate = this.authService.getServerDate;
  // displayedColumns: string[] = ['surgerycode', 'surgeryname'];
  private dataSource = new MatTableDataSource<SurgicalHistoryModel>();
  private surgenid: any;
  applyFilter_grid(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  selectrow(row) {
    this.dashboardService.selectedRowIndex = row.pkSurgeryId;
    this.emrservice.surgeryhistory_added.surgeryName = row.surgeryName;
    this.emrservice.surgeryhistory_added.fkSurgeryCatId = row.fkSurgeryCatId;
    this.emrservice.surgeryhistory_added.shortName = row.shortName;
    this.emrservice.surgeryhistory_added.surgeryCode = row.surgeryCode;
    this.emrservice.surgeryhistory_added.fK_OperationtypeId = row.fK_OperationtypeId;
    this.emrservice.surgeryhistory_added.isActive = row.isActive;
  }
  filtersurgerydata(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if(event.target.value.length >=3 ){
        this.emrservice.GetSurgeryAll(event.target.value,this.stype).pipe(takeUntil(this.destroynewsugical$)).subscribe((item: any) => {
          this.dataSource.data = item;
        },err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
    }else{
      const finddata = this.filerdata(this.helplistservice.surgeryList.slice(), event.target.value);
      if (finddata.length > 0) {
        this.dataSource.data = finddata;
      } else {
        this.dataSource.data =[];
        if (event.target.value.lenght >=3) {
        if (event.target.value != null && event.target.value != '') {
          var pdata = event.target.value
        } else {
          pdata = 0;
        }
        this.emrservice.GetSurgeryAll(pdata,this.stype).pipe(takeUntil(this.destroynewsugical$)).subscribe((item: any) => {
          this.dataSource.data = item;
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
      }
    }
    
  }
  filerdata(items: any[], searchText: string) {
    if(this.stype=='S'){
      let smallchar=searchText?searchText.toLowerCase():'';
      return items ? items.filter(item => item.surgeryName?.toLowerCase().indexOf(smallchar) === 0):[];
    }else{
      return items ? items.filter(item => item.surgeryName.search(new RegExp(searchText, 'i')) > -1) : [];
    }
   
  }

  //displayedColumns_surgerydepartments: string[] = ['surgeryDeptName'];
  //displayedColumns_surgerycategories: string[] = ['surgeryCatName'];

  // surgery_ds = new MatTableDataSource<SurgicalHistoryModel>();
  // displayedColumns_surgery: string[] = ['surgeryCode','surgeryName'];


  surgicalhistory_ds: MatTableDataSource<SurgicalHistoryModel>
  displayedColumns_surgicalhistory: string[] = ['surgeryname', 'surgerydate', 'surgeonname', 'place', 'eye', 'remarks', 'Action'];

  constructor(private dialog: MatDialog,
    private emrservice: EMRService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private opdvisitService: OpdVisitService,
    private dashboardService: DashboardService,
    private helplistservice: HelplistService, private dialogRef: MatDialogRef<NewSurgeryComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) {

    dialogRef.disableClose = true;

  }


  stype:any;
  ngOnInit() {
    this.stype='S';
    this.dataSource.data = this.helplistservice.surgeryList.slice().filter(item => item.isActive == true);
    //this.surgerydepartments_ds.data = this.helplistservice.surgery_departments;
    // this.surgerycategories_ds.data = this.helplistservice.categories;

    this.emrservice.surgicalhistory_client = [];
    this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());

    this.getDoctorBrach();
    this.doctorControll();
    this.emrservice.surgeryhistory_added.SurgeryDate = null;
    this.emrservice.surgeryhistory_added.SurgeonName = '';
    this.emrservice.surgeryhistory_added.place = '';
    this.emrservice.surgeryhistory_added.remarks = '';
  }

  UpdateRowCode(i) {
    this.dataSource.data[i].isEdit = false;
    this.dataSource.data[i].isActive = true;
  }

  updateMaster(value, i, type) {
    if (this.dashboardService.selectedRowIndex > 0) {
      if (type == 1) {
        var surgerycode = value;
      } else {
        var surgeryName = value;
      }
      let payload1 = {
        "IsActive": this.emrservice.surgeryhistory_added.isActive,
        "PkSurgeryId": this.dashboardService.selectedRowIndex,
        "FkSurgeryCatId": this.emrservice.surgeryhistory_added.fkSurgeryCatId,
        "FK_OperationtypeId": this.emrservice.surgeryhistory_added.fK_OperationtypeId,
        "SurgeryCode": surgerycode ? surgerycode : this.emrservice.surgeryhistory_added.surgeryCode,
        "SurgeryName": surgeryName ? surgeryName : this.emrservice.surgeryhistory_added.surgeryName,
        "ShortName": this.emrservice.surgeryhistory_added.shortName,
        "InternationalName": null,
        "ArabicSurgeryName": null,
        "ArabicSurgeryNameWeb": null,
        "IsEdit": true
      }
      this.emrservice.InsertSurgeryMaster(payload1).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
          this.getSergurydata(0,0);

        }

      }, err => {

        this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      });
    } else {

      this.dashboardService.openSnackBar("Surgery ID Not Found", "OK");
    }
  }
  searchType(event) {
    this.stype = event;
  }
  getSerguryArray: any = [];
  getSergurydata(type,searchtype) {
    this.showspinner = true;
    this.getSerguryArray = [];
    this.helplistservice.surgeryList = [];
    this.emrservice.GetSurgeryAll(type,searchtype).pipe(takeUntil(this.destroynewsugical$)).subscribe(x => {
      this.getSerguryArray = x;
      this.helplistservice.surgeryList = this.getSerguryArray;
      this.dataSource.data = this.getSerguryArray.filter(item => item.isActive == true).slice();
      this.showspinner = false;
    }, err => {
      this.showspinner = false;
      // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  getallsurgeries() {
    this.getSergurydata(0,0);
    // this.dataSource.data = this.helplistservice.surgeryList.slice();
  }

  removeselection() {
    this.dataSource.data = this.helplistservice.surgeryList.slice();

    this.catselected = -1;
  }


  filtersurgerylist(row) {
    let catid = row.pkSurgeryCatId;
    this.catselected = catid;

    this.dataSource.data = this.helplistservice.surgeryList.slice().filter(s => s.fkSurgeryCatId == catid);

  }

  deletesurgery(row: Object) {

    this.emrservice.delete_flag = "del_cs_surgery";

    const dialogRef = this.dialog.open(Emr_delete_confirmation_boxComponent, {
      panelClass: 'full-width-dialog',
      width: '40%',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroynewsugical$)).subscribe(result => {
      if (this.emrservice.delete_flag == "del_cs_surgery") {
        const index: number = this.emrservice.surgicalhistory_client.indexOf(row);
        if (index !== -1) {
          this.emrservice.surgicalhistory_client.splice(index, 1);
          this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());
          this.emrservice.delete_flag = null;
        }
      }
      else {
        // do nothing
      }

    });



  }
  //delete all
  deleteall() {
    this.emrservice.delete_flag = "del_cs_all_surgery"


    const dialogRef = this.dialog.open(Emr_delete_confirmation_boxComponent, {

      panelClass: 'full-width-dialog',
      width: '40%',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroynewsugical$)).subscribe(result => {
      console.log("flag " + this.emrservice.delete_flag);

      if (this.emrservice.delete_flag == "del_cs_all_surgery") {
        this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client = []);;
      }
      else {
        // do nothing
      }

    });



  }

  addsurgery(event) {
     const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    },500);
    if (this.emrservice.surgeryhistory_added.surgeryName != undefined) {
      if (this.emrservice.surgeryhistory_added.surgeryName.toLowerCase() != 'nil' && this.emrservice.surgeryhistory_added.surgeryName.toLowerCase() != 'nill' && this.emrservice.surgeryhistory_added.surgeryName.toLowerCase() != 'na') {
        if (this.emrservice.surgeryhistory_added.surgeryName != undefined && this.emrservice.surgeryhistory_added.eye != undefined) {
        
            this.emrservice.get_surgeries(this.emrservice.visitid).subscribe((apiResponse: any[]) => {
            
              const normalizeSurgeryName = (name: string) => {
                return name.replace(/\s*\(.*\)\s*/, "").trim(); 
              };
            
               var isDuplicateInApi;
              if( this.emrservice.surgeryhistory_added.SurgeryDate){
                const filterdata =apiResponse.filter(item=> ( Date.parse(this.datepipe.transform(new Date(item.surgeryDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(new Date(this.emrservice.surgeryhistory_added.SurgeryDate), "yyyy-MM-dd").toString())));
                var bindeye =this.emrservice.surgeryhistory_added.surgeryName +' ('+this.emrservice.surgeryhistory_added.eye +')';
                isDuplicateInApi = filterdata.some((entry: any) => {
                  return ( entry.surgeryName.toString().replace(/[|&;$%@"<>()+,]/g, "").split(' ').join('').toLowerCase() == bindeye.toString().replace(/[|&;$%@"<>()+,]/g, "").split(' ').join('').toLowerCase())
                });
               
             
              }else{
               isDuplicateInApi = apiResponse.some((entry: any) => {
                  return normalizeSurgeryName(entry.surgeryName) == normalizeSurgeryName(this.emrservice.surgeryhistory_added.surgeryName);
                });
              }
            if (isDuplicateInApi) {
              this.dashboardService.openSnackBar("Already exists in the list", "OK");
              return;
            }
         

              this.setotherfields();
              this.emrservice.surgicalhistory_client.unshift(this.emrservice.surgeryhistory_added);
              this.emrservice.surgeryhistory_added = {};
              this.surgenid = 0;
              this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());

              this.dashboardService.selectedRowIndex = -1;
            
        });

        } else {
          this.dashboardService.openSnackBar("Please select at least one surgery and eye", "OK");
        }
      } else {
        this.setotherfields();
        this.emrservice.surgicalhistory_client.unshift(this.emrservice.surgeryhistory_added);
        this.emrservice.surgeryhistory_added = {};
        this.surgenid = 0;
        this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());
        this.dashboardService.selectedRowIndex = -1;
      }
    } else {
      this.dashboardService.openSnackBar("Please select at least one surgery", "OK");
    }
  }

  closedialog() {
    this.dialogRef.close(0);
  }


  setotherfields() {

    if (this.emrservice.surgeryhistory_added.SurgeryDate != null) {
      this.emrservice.surgeryhistory_added.SurgeryDate =
        this.datepipe.transform(this.emrservice.surgeryhistory_added.SurgeryDate, "MM-dd-yyyy").toString();

    }
    // else {
    //   this.emrservice.surgeryhistory_added.SurgeryDate =
    //     this.datepipe.transform(new Date(), "MM-dd-yyyy").toString();
    // }
    this.emrservice.surgeryhistory_added.pkSurgeryId = this.dashboardService.selectedRowIndex;
    this.emrservice.surgeryhistory_added.pkTranId = 0;
    this.emrservice.surgeryhistory_added.fK_SurgeonId = this.surgenid;

    this.emrservice.surgeryhistory_added.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.surgeryhistory_added.pkSynchId = null;
    this.emrservice.surgeryhistory_added.fkReg = null;


    // console.log("start date " +  this.emrservice.pasthistory_added.startDate);

  }

  // applyFilter_surgeries(filterValue: string) {
  //  // this.surgery_ds.filter = filterValue.trim().toLowerCase();
  // }

  // applyFilter(filterValue: string) {
  //   this.surgerydepartments_ds.filter = filterValue.trim().toLowerCase();
  // }


  savesurgeries() {
    // save data first 
    this.dialogRef.close(this.surgicalhistory_ds.data);
    // if (this.surgicalhistory_ds.data.length == 0) {
    //   return this.dashboardService.openSnackBar("Please Add the Surgery Details","Ok")
    // }
    // this.save_surgeries_to_server();
  }

  save_surgeries_to_server() {
    this.emrservice.save_surgeries_to_server().pipe(takeUntil(this.destroynewsugical$)).subscribe(
      data => this.success_surgeries_saved(data), err => this.failed_surgeries_saved(err)
    )
  }
  success_surgeries_saved(data) {
    this.dialog.closeAll();
    this.emrservice.surgicalhistory_client = [];
    this.dashboardService.openSnackBar("Record saved successfully ", "OK");
  }
  failed_surgeries_saved(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //get schedule type
  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroynewsugical$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      this.doctorControll();
    }
    else {
      this.opdvisitService.doctors = data;
      this.doctorControll();
    }


  }
  failed_doctors(err) {
   if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
  }

  //autocomplet
  doctorControll() {

    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.opdvisitService.doctors.slice())
      );

  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.opdvisitService.doctors.filter(country =>
      country.userName?.toLowerCase().indexOf(filterValue) === 0);

  }

  getdoctorobj(e: any) {
    var val = e.option.value;
    this.emrservice.surgeryhistory_added.SurgeonName = val.userName;
    this.surgenid = val.userId

  }

  CheckinputDoctor(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.doctorControll();
      this.surgenid = 0;
      // this.ShowDoctorName = null;
    }
  }


  AddNewsurgeriespopup(): void {
    const dialogRef = this.dialog.open(AddNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '55vw',
      height: 'auto',
      width: '100%',
      disableClose: true
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroynewsugical$)).subscribe(result => {
      if (result != 0) {
        this.getallsurgeries();
      }

    });
  }

  deActiveSurgery(surgeryid) {

    if (surgeryid > 0) {

      let payload2 = {
        "PkSurgeryId": surgeryid, "IsActive": false, "IsHidden": true, "IsEdit": true
      }
      this.emrservice.InsertSurgeryMaster(payload2).pipe(takeUntil(this.destroynewsugical$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.dashboardService.openSnackBar("Record De-Active Successfully", "OK");

          this.getSergurydata(0,0);
        }

      }, err => {
        // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.dashboardService.openSnackBar("Click isActive checkbox", "OK");
    }


  }
  refReasonPOpup(type) {

    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroynewsugical$)).subscribe(result => {
      if (result != 0) {
        if (type == 18) {
          this.emrservice.surgeryhistory_added.place = result;
        }
      }
    });
  }
  getToday(): string {
    return this.authService.getServerDate;
  }

  refReasonPOpups(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroynewsugical$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.emrservice.surgeryhistory_added.remarks = result;
        }

      }
    });
  }


 
  ngOnDestroy() {
    this.destroynewsugical$.next(true);
    this.destroynewsugical$.unsubscribe();
    this.filterTerm = null;
    this.showspinner = null;
    this.catselected = null;
    this.DoctorCtrl = null;
    this.filteredDoctorArray = null;
    this.todaysdate = null;
    this.dataSource = null;
    this.surgenid = null;
    this.displayedColumns_surgicalhistory = null;
  }
}
